/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";
// @ts-ignore
import { AuthGroupManyRequestDto } from "../models";
// @ts-ignore
import { AuthGroupRegularResponseDto } from "../models";

/**
 * AuthGroupsControllerApi - axios parameter creator
 * @export
 */
export const AuthGroupsControllerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {AuthGroupManyRequestDto} authGroupManyRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAuthGroups: async (
      authGroupManyRequestDto: AuthGroupManyRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authGroupManyRequestDto' is not null or undefined
      assertParamExists(
        "createAuthGroups",
        "authGroupManyRequestDto",
        authGroupManyRequestDto
      );
      const localVarPath = `/api/v2/auth-group`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authGroupManyRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AuthGroupManyRequestDto} authGroupManyRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAuthGroups: async (
      authGroupManyRequestDto: AuthGroupManyRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authGroupManyRequestDto' is not null or undefined
      assertParamExists(
        "deleteAuthGroups",
        "authGroupManyRequestDto",
        authGroupManyRequestDto
      );
      const localVarPath = `/api/v2/auth-group`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authGroupManyRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllAuthGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v2/auth-group`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthGroupsControllerApi - functional programming interface
 * @export
 */
export const AuthGroupsControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthGroupsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AuthGroupManyRequestDto} authGroupManyRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAuthGroups(
      authGroupManyRequestDto: AuthGroupManyRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createAuthGroups(
        authGroupManyRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["AuthGroupsControllerApi.createAuthGroups"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AuthGroupManyRequestDto} authGroupManyRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAuthGroups(
      authGroupManyRequestDto: AuthGroupManyRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAuthGroups(
        authGroupManyRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["AuthGroupsControllerApi.deleteAuthGroups"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllAuthGroups(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<AuthGroupRegularResponseDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAuthGroups(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["AuthGroupsControllerApi.getAllAuthGroups"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * AuthGroupsControllerApi - factory interface
 * @export
 */
export const AuthGroupsControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthGroupsControllerApiFp(configuration);
  return {
    /**
     *
     * @param {AuthGroupManyRequestDto} authGroupManyRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAuthGroups(
      authGroupManyRequestDto: AuthGroupManyRequestDto,
      options?: any
    ): AxiosPromise<number> {
      return localVarFp
        .createAuthGroups(authGroupManyRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AuthGroupManyRequestDto} authGroupManyRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAuthGroups(
      authGroupManyRequestDto: AuthGroupManyRequestDto,
      options?: any
    ): AxiosPromise<number> {
      return localVarFp
        .deleteAuthGroups(authGroupManyRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllAuthGroups(options?: any): AxiosPromise<Array<AuthGroupRegularResponseDto>> {
      return localVarFp.getAllAuthGroups(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthGroupsControllerApi - object-oriented interface
 * @export
 * @class AuthGroupsControllerApi
 * @extends {BaseAPI}
 */
export class AuthGroupsControllerApi extends BaseAPI {
  /**
   *
   * @param {AuthGroupManyRequestDto} authGroupManyRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthGroupsControllerApi
   */
  public createAuthGroups(
    authGroupManyRequestDto: AuthGroupManyRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return AuthGroupsControllerApiFp(this.configuration)
      .createAuthGroups(authGroupManyRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AuthGroupManyRequestDto} authGroupManyRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthGroupsControllerApi
   */
  public deleteAuthGroups(
    authGroupManyRequestDto: AuthGroupManyRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return AuthGroupsControllerApiFp(this.configuration)
      .deleteAuthGroups(authGroupManyRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthGroupsControllerApi
   */
  public getAllAuthGroups(options?: RawAxiosRequestConfig) {
    return AuthGroupsControllerApiFp(this.configuration)
      .getAllAuthGroups(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
